// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgressBar-module__wrapper--moVIy{box-sizing:border-box;width:100%;padding:1.722rem 0}.ProgressBar-module__outerBar--PId2K{background:#d5d5e2;border-radius:.389rem;width:100%;max-width:30.444rem;height:.778rem;margin:auto;overflow:hidden}.ProgressBar-module__innerBar--QU4Y_{background:#0293b9;width:0;height:.778rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ProgressBar-module__wrapper--moVIy`,
	"outerBar": `ProgressBar-module__outerBar--PId2K`,
	"innerBar": `ProgressBar-module__innerBar--QU4Y_`
};
export default ___CSS_LOADER_EXPORT___;
